function isAriaTruthy(value) {
    return value === true || value === 'true';
}
const KEY_MAP = {
    '⌘': 'command',
    '⌥': 'option',
    '⌃': 'control',
    Ctrl: 'control',
    '⇧': 'shift',
    '`': 'backquote',
    ']': 'bracketRight',
    '[': 'bracketLeft',
    '⌫': 'backspace',
    "'": 'quote',
    ';': 'semicolon',
    ',': 'comma',
    '.': 'period',
    '-': 'minus',
    '+': 'plus',
};
/**
 * Turns a string intended for displaying a shortcut into a stirng intended to be read by
 * a screen reader as a shortcut.
 */
function toAriaKeyshortcuts(str, strings) {
    if (/\+./.test(str)) {
        // On Windows, shortcuts are typically already written out as "Ctrl+Shift+K"
        // but sometimes use abbreviations for keys like ⌫ for backspace, so just replace those
        return str
            .split(/\+(?=.)/)
            .map((key) => lookup(key, strings))
            .join('+');
    }
    // Otherwise assume the shortcut is written using symbols like ⌘⇧K and
    // convert those character by character
    let result = '';
    for (const char of str) {
        const val = lookup(char, strings);
        result += result ? `+${val}` : val;
    }
    return result;
}
function lookup(key, strings) {
    const stringName = KEY_MAP[key];
    if (!stringName)
        return key;
    return strings[stringName]();
}

export { isAriaTruthy, toAriaKeyshortcuts };
//# sourceMappingURL=aria.js.map
